import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex } from '@qga/roo-ui/components';

import StarRating from '@shared/v2/components/StarRating';

import Heading from '@/components/Heading';
import useDestination from '@/hooks/useDestination';
import usePropertyContent from '@/hooks/usePropertyContent';
import MainCTA from '@/v2/components/pages/PackageViewV2/components/MainCTA';
import PropertyDestination from '@/v2/components/ui/PropertyTitle/components/PropertyDestination';
import PropertyTags from '@/v2/components/ui/PropertyTitle/components/PropertyTags';

const StyledBox = styled(Box)`
  align-self: end;
`;

const StyledBoxPropertyTags = styled(Box)`
  line-height: 1.2rem;
`;

interface Props {
  main?: boolean;
}

const PackageHeader = React.memo(({ main = true }: Props) => {
  const destination = useDestination();
  const destinationName = destination?.title;
  const propertyContent = usePropertyContent();
  const { name, rating, ratingType } = propertyContent;
  const { tags } = propertyContent;

  return (
    <Flex
      justifyContent="space-between"
      flexDirection={['column', null, 'row']}
    >
      <Box>
        <Box mb={[2, null, 1]}>
          <PropertyDestination destinationName={destinationName} />
        </Box>
        {main && (
          <Heading.h1
            fontSize={['24px', null, '2xl']}
            fontWeight={['700', null, null]}
            lineHeight={['30px', null, '40px']}
            letterSpacing={[0, null, null]}
          >
            {name}
          </Heading.h1>
        )}
        {!main && (
          <Heading.h2 fontSize={['28px', null, '2xl']}>{name}</Heading.h2>
        )}
        <Flex
          flexDirection={['column', null, 'row']}
          justifyContent="start"
          alignItems={[null, null, 'center']}
          pt={1}
        >
          <Box my={'5px'}>
            <StarRating rating={rating} ratingType={ratingType} size={16} />
          </Box>
          {tags && (
            <StyledBoxPropertyTags ml={[null, null, '16px']} pt={[2, null, 0]}>
              <PropertyTags tags={tags} textColor="text.placeHolder" />
            </StyledBoxPropertyTags>
          )}
        </Flex>
      </Box>
      <StyledBox display={['none', null, 'initial']}>
        <MainCTA isMobileVersion={false} handleReserve={() => {}} />
      </StyledBox>
    </Flex>
  );
});

export default PackageHeader;
